import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBriefcase,
  faChartLine,
  faCalculator,
  faChartPie,
  faFileInvoiceDollar,
  faFileSignature,
  faEnvelope,
  faCopy,
  faFolderOpen,
  faStickyNote,
  faCalendarAlt,
  faFileExport,
  faFileImport,
  faPercentage,
  faBan,
  faSlidersH,
  faExchangeAlt,
  faHistory,
  faUser,
  faTasks,
  faMoneyBillWave,
  faUsers,
  faUserTie,
  faAddressCard,
  faUniversity,
  faClipboardList,
  faUserCircle,
  faInfoCircle,
  faChevronRight,
  faClipboardCheck,
  faShieldAlt,
  faLayerGroup,
  faFileContract,
  faUserSecret,
  faBuilding,
  faCreditCard
} from "@fortawesome/free-solid-svg-icons";

const ICON_MAP = {
  "Loan Overview": faInfoCircle,
  "Sales Tracker": faChartLine,
  "Cashflow Model": faCalculator,
  "Cashflow Output": faChartPie,
  "Completion Statement": faFileInvoiceDollar,
  "Loan Model": faFileSignature,
  "Letters": faFileContract,
  "Master Templates": faCopy,
  "Loan Documents": faFolderOpen,
  "Notes": faStickyNote,
  "Monthly Statements": faCalendarAlt,
  "Outbound Payments": faFileExport,
  "Inbound Payments": faFileImport,
  "Fees": faPercentage,
  "Loan Termination": faBan,
  "Loan Adjustment": faSlidersH,
  "CARS Integration": faExchangeAlt,
  "Change Logs": faHistory,
  "Profile": faUser,
  "Tasks View": faTasks,
  "Portfolio Summary": faBriefcase,
  "Inbound Payment Allocation": faMoneyBillWave,
  "Exposure Groups": faLayerGroup,
  "Borrower  Details": faUserTie,
  "Contact Details": faAddressCard,
  "Third Party Bank Details": faUniversity,
  "Audit Logs": faClipboardList,
  "Borrower Overview": faUserCircle,
  "Account Management": faUsers,
  "User Management": faUserCircle,
  "User Groups Management": faUserTie,
  "User Audit Logs": faClipboardList,
  "User Activity Logs": faHistory,
  "Redemption Letter": faEnvelope,
  "Annual Review": faClipboardCheck,
  "Risk Rating": faShieldAlt,
  "Default Tasks": faTasks,
  "Wishlist": faTasks,
  "Anonymisation Queue": faUserSecret,
  "Company House Overview": faBuilding,
  "Payments": faCreditCard,
};

const startsWithUniqueChar = (name) => {
  if (!name) return false;
  const firstChar = name.trim().charAt(0);
  // Returns true if first character is not alphanumeric (e.g. arrows, symbols)
  return !/[a-zA-Z0-9]/.test(firstChar);
};

export const hasMenuIcon = (name) => {
  if (ICON_MAP[name]) return true;
  if (startsWithUniqueChar(name)) return false;
  return true; // Use default for others
};

const M_MenuIcon = ({ name, compact = false, ...props }) => {
  const icon = ICON_MAP[name];

  if (icon) {
    return (
      <FontAwesomeIcon
        icon={icon}
        style={{ fontSize: "16px", ...props.style }}
        {...props}
      />
    );
  }

  if (startsWithUniqueChar(name)) {
    // In rail/compact mode, fall back to the first character of the title
    // so these items still show *something* instead of disappearing.
    if (compact) {
      const firstChar = (name || "").trim().charAt(0) || "?";
      return (
        <span
          aria-hidden="true"
          style={{
            fontSize: "16px",
            fontWeight: 700,
            lineHeight: 1,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            ...props.style,
          }}
        >
          {firstChar}
        </span>
      );
    }
    return null;
  }

  return (
    <FontAwesomeIcon
      icon={faChevronRight}
      style={{
        fontSize: "10px",
        opacity: 0.4,
        marginLeft: "2px",
        ...props.style,
      }}
      {...props}
    />
  );
};

M_MenuIcon.propTypes = {
  name: PropTypes.string,
  style: PropTypes.object,
  compact: PropTypes.bool,
};

export default M_MenuIcon;
